import React, {useEffect, useState} from 'react';
import {observer} from "mobx-react";
import {useStores} from "../../../stores/Context";
import styles from "./WidgetIndicateurNiveaux.module.scss"
import OptimizedSlider from "../../SwipeableViews/OptimizedSlider";
import SwipeableViews from "react-swipeable-views";
import VoirIndicateurNiveaux from "./VoirIndicateurNiveaux";
import {useParams} from "react-router-dom";
import SidebarNiveaux from "../../SidebarNiveaux";
import {GEN_DROP_ZONES} from "../../../utils/DragAndDrop";
import ModalPrimary from "../../../boiteAOutils/ModalPrimary";
import IndicatorInsights from "./IndicatorInsights";
import IndicatorLevelRail from "./IndicatorLevelRail";

const LevelLoadingTransition = ({leaving}) => (
    <div
        className={`${styles.levelsLoadingOverlay} ${leaving ? styles.levelsLoadingOverlayLeaving : ''}`}
        role="status"
        aria-live="polite"
    >
        <div className={styles.levelsLoadingCard}>
            <div className={styles.levelsLoadingMark} aria-hidden="true">
                <i/>
                <i/>
                <i/>
            </div>
            <strong>Préparation de votre espace</strong>
            <span>Les indicateurs arrivent.</span>
        </div>
    </div>
);

const WidgetIndicateurNiveaux = observer(({level}) => {
    const {ent} = useParams();
    const {niveauxIndicateurStore, widgetStore, uiStore} = useStores();
    const [configWidgetIndicateur, setConfigWidgetIndicateur] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [showSidebar, setShowSidebar] = useState(false);
    const [showDeleteLevel, setShowDeleteLevel] = useState(false);
    const [loading, setLoading] = useState(true);
    const [showLoadingOverlay, setShowLoadingOverlay] = useState(false);
    const [loadingLeaving, setLoadingLeaving] = useState(false);
    const [showInsights, setShowInsights] = useState(true);

    useEffect(() => {
        const loadWidgetData = async () => {
            setLoading(true); // chargement en cour
            try {
                const value = await widgetStore.getWidgetDataConfigById(niveauxIndicateurStore.idWidgetIndicateurOuvert);
                setConfigWidgetIndicateur(value);
                await niveauxIndicateurStore.loadNiveaux(niveauxIndicateurStore.idWidgetIndicateurOuvert, 'lecture', ent);
            } catch (error) {
                console.log("error", error);
            } finally {
                setLoading(false); // chargement est terminé
            }
        };

        if (configWidgetIndicateur.length === 0) {
            loadWidgetData();
        }
    }, [niveauxIndicateurStore.idWidgetIndicateurOuvert]);

    useEffect(() => {
        if (loading) {
            setShowLoadingOverlay(true);
            setLoadingLeaving(false);
            return undefined;
        }

        if (!showLoadingOverlay) return undefined;

        setLoadingLeaving(true);
        const fadeTimer = window.setTimeout(() => {
            setShowLoadingOverlay(false);
            setLoadingLeaving(false);
        }, 360);

        return () => window.clearTimeout(fadeTimer);
    }, [loading, showLoadingOverlay]);

    const handleCloseSidebar = () => {
        setShowSidebar(false);
    }

    const handleChangeLevel = (level) => {
        niveauxIndicateurStore.updateCurrentLevel(level.id);
    }

    const handleChangeIndex = (index, indexLatest, meta) => {
        // Ajoute la propriété "active" à l'élément
        niveauxIndicateurStore.updateCurrentLevel(niveauxIndicateurStore.levels[index].id);
    };

    const DeleteLevel = ({show}) => {
        if (!show) return null;

        const deleteLevel = () => {
            niveauxIndicateurStore.removeCurrentLevel(ent);
            setShowDeleteLevel(false);
        }

        return (
            <ModalPrimary
                textTitle={"Cette action supprimera la page actuelle, voulez-vous continuer ?"}
                textBtnValidate={"Oui, continuer"}
                textBtnCancel={"Non, annuler"}
                onValidate={() => deleteLevel()}
                onCancel={() => setShowDeleteLevel(false)}
            />
        )
    }

    const returnHome = () => {
        setConfigWidgetIndicateur([]);
        niveauxIndicateurStore.idWidgetIndicateurOuvert = '';
        uiStore.closeConsultingIndicateurWidget()
    }

    if (!editMode && showInsights) {
        return (
            <div className={styles.insightsShell}>
                <IndicatorLevelRail
                    viewingInsights={true}
                    onOpenInsights={() => setShowInsights(true)}
                    onReturnDashboard={returnHome}
                />
                <main className={styles.insightsContent}>
                    <IndicatorInsights
                        idWidget={niveauxIndicateurStore.idWidgetIndicateurOuvert}
                    />
                    {showLoadingOverlay && <LevelLoadingTransition leaving={loadingLeaving}/>}
                </main>
            </div>
        );
    }

    return (
        <div className={`contentNiv1 ${!editMode ? styles.levelsShell : ''}`}>
            {!editMode && <IndicatorLevelRail
                viewingInsights={showInsights}
                onOpenInsights={() => setShowInsights(true)}
                onReturnDashboard={returnHome}
            />}
            <div className={!editMode ? styles.levelsContent : ''}>
                {showLoadingOverlay && <LevelLoadingTransition leaving={loadingLeaving}/>}
                <div className={`${styles.levelsWorkspace} ${loading ? styles.levelsWorkspaceLoading : styles.levelsWorkspaceReady}`}>
                    {
                        editMode && !showSidebar && (
                            <div className={styles.addObjectButton} onClick={() => {
                                setShowSidebar(true);
                            }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="39" viewBox="0 0 40 39"
                                     fill="none">
                                    <path d="M20 4.875V34.125" stroke="white" strokeWidth="4"/>
                                    <path d="M5.375 19.5H34.6236" stroke="white" strokeWidth="4"/>
                                </svg>
                            </div>
                        )
                    }

                    {showSidebar && (
                        <>
                            <SidebarNiveaux handleClose={handleCloseSidebar}/>
                            <div
                                className={`dropZone niveauIndicateur`}
                                style={{zIndex: -1, overflow: 'hidden'}}
                            >
                                {GEN_DROP_ZONES()}
                            </div>
                        </>
                    )
                    }


                    <div className={!editMode ? styles.editButtonContainer : styles.cancelEditButtonContainer}
                         onClick={() => {
                             if (editMode) {
                                 setShowSidebar(false);
                                 setEditMode(false);
                                 setShowInsights(true);
                                 return;
                             }
                             setShowInsights(false);
                             setEditMode(true);
                         }}>
                        {editMode ? (
                            <div className="grid grid-cols-5">
                                <div className="col-span-1">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"
                                         fill="none">
                                        <path
                                            d="M2.69242 31.0563C1.86399 31.0563 1.19242 31.7278 1.19242 32.5563C1.19242 33.3847 1.86399 34.0563 2.69242 34.0563V31.0563ZM7.79815 12.9393C7.21236 13.5251 7.21236 14.4749 7.79815 15.0607L17.3441 24.6066C17.9299 25.1924 18.8796 25.1924 19.4654 24.6066C20.0512 24.0208 20.0512 23.0711 19.4654 22.4853L10.9801 14L19.4654 5.51472C20.0512 4.92893 20.0512 3.97919 19.4654 3.3934C18.8796 2.80761 17.9299 2.80761 17.3441 3.3934L7.79815 12.9393ZM2.69242 34.0563H27.5714V31.0563H2.69242V34.0563ZM27.5714 34.0563C33.4609 34.0563 38.1924 29.2061 38.1924 23.2781H35.1924C35.1924 27.5978 31.756 31.0563 27.5714 31.0563V34.0563ZM38.1924 23.2781C38.1924 17.3501 33.4609 12.5 27.5714 12.5V15.5C31.756 15.5 35.1924 18.9584 35.1924 23.2781H38.1924ZM27.5714 12.5H8.85881V15.5H27.5714V12.5Z"
                                            fill="#FBFDFE"/>
                                    </svg>
                                </div>
                                <div className="col-span-4">
                                    <div className="flex justify-center">
                                        <div className="btnAction">
                                            <div>Revenir vers la page indicateur</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="grid grid-cols-5">
                                <div className="col-span-1">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="38" viewBox="0 0 40 38"
                                         fill="none">
                                        <path d="M25.7177 7.81824V1.91016H2V25.5425H8.77649" stroke="#002335"
                                              strokeWidth="3"
                                              strokeDasharray="3 3"/>
                                        <path d="M21.8601 32.812H10.0439V9.17969H33.6763V20.9959" stroke="#002335"
                                              strokeWidth="3"/>
                                        <path
                                            d="M29.2267 36.0919L21.9158 20.008L37.9998 27.3189L31.6637 29.7558L29.2267 36.0919Z"
                                            stroke="#002335" strokeWidth="2.5" strokeLinejoin="round"/>
                                    </svg>
                                </div>
                                <div className="col-span-4">
                                    <div className="flex justify-center">
                                        <div className="btnAction">
                                            <div>Créer / modifier ma page indicateur</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className={styles.container}>
                        {
                            (niveauxIndicateurStore.levels.length !== 1 || editMode) && (
                                <div className={styles.swipeableIndexContainer}>
                                    {
                                        (niveauxIndicateurStore.levels.length !== 1 || editMode) &&
                                        <div className={styles.widgetCreatePagination}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"
                                                 viewBox="0 0 40 40"
                                                 className={niveauxIndicateurStore.currentIndex !== 0 && "cursor-pointer"}
                                                 fill="none" onClick={() => {
                                                if (niveauxIndicateurStore.currentIndex > 0) {
                                                    handleChangeLevel(niveauxIndicateurStore.levels[niveauxIndicateurStore.currentIndex - 1]);
                                                }
                                            }}>
                                                <path d="M26.6055 31.543L15.0002 19.9377L26.6055 8.3324"
                                                      stroke={niveauxIndicateurStore.currentIndex === 0 ? "#DBE3E7" : "#70787B"}
                                                      strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>

                                            <div className={styles.paginationIcons}>
                                                {niveauxIndicateurStore.levels.map((level, i) => (
                                                    level.type === 'level' && (
                                                        <>
                                                            {/*<span*/}
                                                            {/*    className={`${styles.icone_nav} ${level.active && styles.active_bulle}`}*/}
                                                            {/*    key={"icone_nav_".data} onClick={() => handleChangeLevel(level, i)}/>*/}
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="20"
                                                                height="20"
                                                                viewBox="0 0 20 20"
                                                                fill="none"
                                                                onClick={() => handleChangeLevel(level, i)}
                                                                key={"icone_nav_".data}
                                                            >
                                                                <circle cx="10" cy="10" r="10"
                                                                        fill={level.active ? "#002335" : '#DBE3E7'}/>
                                                            </svg>
                                                        </>
                                                    )
                                                ))}
                                                {editMode && (
                                                    <svg
                                                        width="20"
                                                        height="20"
                                                        viewBox="0 0 20 20"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className={"cursor-pointer"}
                                                        // onClick={() => console.log("niveauxIndicateurStore.addLevel()")}
                                                        onClick={() => niveauxIndicateurStore.addLevel(ent)}
                                                    >
                                                        <path
                                                            d="M1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10C19 14.9706 14.9706 19 10 19H1.25C1.11193 19 1 18.8881 1 18.75V10Z"
                                                            stroke="#00B0FF" strokeWidth="2"
                                                        />
                                                        <path d="M10 4V16" stroke="#00B0FF" strokeWidth="2"/>
                                                        <path d="M4 10H16" stroke="#00B0FF" strokeWidth="2"/>
                                                    </svg>

                                                )}
                                            </div>

                                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"
                                                 viewBox="0 0 40 40"
                                                 fill="none"
                                                 className={niveauxIndicateurStore.currentIndex + 1 < niveauxIndicateurStore.levels.length && "cursor-pointer"}
                                                 onClick={() => {
                                                     if (niveauxIndicateurStore.currentIndex + 1 < niveauxIndicateurStore.levels.length) {
                                                         handleChangeLevel(niveauxIndicateurStore.levels[niveauxIndicateurStore.currentIndex + 1]);
                                                     }
                                                 }}
                                            >
                                                <path d="M15 8.33398L26.6053 19.9393L15 31.5446"
                                                      stroke={niveauxIndicateurStore.currentIndex + 1 === niveauxIndicateurStore.levels.length ? "#DBE3E7" : "#70787B"}
                                                      strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </div>
                                    }
                                </div>
                            )
                        }
                        { /* Supprimer page indicateur actuel, si mode edition et que l'indicateur ait plus qu'une page */
                            (editMode && niveauxIndicateurStore.levels.length > 1) && (
                                <div className={styles.deletePageButton} onClick={() => {
                                    setShowDeleteLevel(!showDeleteLevel);
                                }
                                }>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                                         viewBox="0 0 16 16" fill="none">
                                        <path
                                            d="M2.80939 12.1492L2.38523 3.66602H13.6161L13.1919 12.1492C13.1121 13.7458 11.7943 14.9993 10.1957 14.9993H5.80565C4.20703 14.9993 2.88922 13.7458 2.80939 12.1492Z"
                                            stroke="#F82121" strokeWidth="2"/>
                                        <path
                                            d="M5.66602 3H10.3327C10.3327 1.89543 9.43725 1 8.33268 1H7.66601C6.56145 1 5.66602 1.89543 5.66602 3Z"
                                            stroke="#F82121" strokeWidth="2"/>
                                        <path d="M0.666016 3.33398H15.3327" stroke="#F82121" strokeWidth="2"/>
                                        <path d="M10 7.33398V10.6673" stroke="#F82121" strokeWidth="2"/>
                                        <path d="M6 7.33398V10.6673" stroke="#F82121" strokeWidth="2"/>
                                    </svg>
                                    <span>Supprimer la page</span>
                                </div>
                            )

                        }
                        <DeleteLevel show={showDeleteLevel}/>

                        <SwipeableViews
                            className={"swipeable_views_lecture_indicateur"}
                            disabled={uiStore.isDragging}
                            /* Désactive le swipe à la souris, car effet de bord quand on drag les éléments
                             * Pour le réactiver, il faut gerer mieux levenement onMouseDown et onMouseUp
                             */
                            // enableMouseEvents
                            index={niveauxIndicateurStore.currentIndex}
                            hysteresis={0.9}
                            onChangeIndex={handleChangeIndex}>
                            {
                                niveauxIndicateurStore.levels.map((level, i) => (
                                    level.type === 'level' && (
                                        <OptimizedSlider
                                            key={level.id}
                                            current={niveauxIndicateurStore.currentIndex}
                                            elKey={i}
                                            size={niveauxIndicateurStore.levels.length}
                                        >
                                            <VoirIndicateurNiveaux level={level} editing={editMode}/>
                                        </OptimizedSlider>
                                    )
                                ))
                            }
                        </SwipeableViews>
                    </div>
                </div>
            </div>
        </div>

    );
});

export default WidgetIndicateurNiveaux;
